/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface Props {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  startDate: string;
  setStartDate: (val: string) => void;
  endDate: string;
  setEndDate: (val: string) => void;
  clearFilters: () => void;

  searchPlaceholder?: string;
  showDateFilter?: boolean;

  t: any;
}

const LotUsageFilters: React.FC<Props> = ({
  searchTerm,
  setSearchTerm,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  clearFilters,
  searchPlaceholder,
  showDateFilter = true,
  t
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Date Range Filter */}
      {showDateFilter && (
        <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-1.5 shadow-sm">
          <span className="material-symbols-outlined text-slate-400 text-sm">
            {t('mediaPowder.icons.calendar_today')}
          </span>
          <input 
            type="date" 
            className="text-[10px] font-bold uppercase tracking-widest text-slate-600 bg-transparent border-none outline-none focus:ring-0 appearance-none"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <span className="text-slate-300 font-bold">
            {t('mediaPowder.filter_list.to')}
          </span>
          <input 
            type="date" 
            className="text-[10px] font-bold uppercase tracking-widest text-slate-600 bg-transparent border-none outline-none focus:ring-0 appearance-none"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      )}

      {/* Search */}
      <div className="relative">
        <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">
          {t('mediaPowder.filter_list.search')}
        </span>
        <input 
          type="text" 
          placeholder={searchPlaceholder || t('mediaPowder.filter_list.searchTransactions')}
          className="pl-9 pr-4 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-medium focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 w-48 transition-all"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Clear Filters */}
      {(searchTerm || startDate || endDate) && (
        <button 
          onClick={clearFilters}
          className="text-[9px] font-black text-red-500 uppercase tracking-widest hover:underline"
        >
          {t('mediaPowder.filter_list.clearFilters')}
        </button>
      )}

    </div>
  );
};

export default LotUsageFilters;